import { useHotEditor } from "@handsontable/react-wrapper";
import { useCallback, useRef } from "react";
import { formatISO, parseISO } from "date-fns";
import {
    DatePicker,
    DatePickerProps,
} from "../forms/dates/DatePicker/DatePicker";
import styles from "./spreadsheet-editor.module.scss";

export const SpreadsheetDateEditor: React.FC = () => {
    const mainElementRef = useRef<HTMLDivElement>(null);
    const stopMousedownPropagation = (e: React.MouseEvent) => {
        e.stopPropagation();
    };
    const { value, setValue, finishEditing } = useHotEditor<string>({
        onOpen: () => {
            if (mainElementRef.current) {
                mainElementRef.current.style.display = "block";
            }
        },
        onPrepare: (
            _row,
            _column,
            _prop,
            TD,
            // eslint-disable-next-line max-params-no-constructor/max-params-no-constructor
        ) => {
            const tdPosition = TD.getBoundingClientRect();

            if (!mainElementRef.current) {
                return;
            }
            mainElementRef.current.style.left = `${
                tdPosition.left + window.pageXOffset
            }px`;
            mainElementRef.current.style.top = `${
                tdPosition.top + window.pageYOffset
            }px`;
            mainElementRef.current.style.width = `${tdPosition.width}px`;
            mainElementRef.current.style.height = `${tdPosition.height}px`;
        },
        onClose: () => {
            if (mainElementRef.current) {
                mainElementRef.current.style.display = "none";
            }
        },
    });

    const handleChange: DatePickerProps["onChange"] = useCallback(
        (newValue: Date | undefined) => {
            if (!newValue) {
                return;
            }

            const formatted = formatISO(newValue, { representation: "date" });
            setValue(formatted);
            finishEditing();
        },
        [setValue, finishEditing],
    );

    const currentValueAsDate = value ? parseISO(value) : undefined;

    return (
        <div
            className={styles.container}
            ref={mainElementRef}
            onMouseDown={stopMousedownPropagation}
        >
            <DatePicker
                initialValue={currentValueAsDate}
                onChange={handleChange}
                maxDetail="month"
                value={currentValueAsDate}
                className={styles.datePicker}
            />
        </div>
    );
};
